import React from "react";
import styles from './ResultsGeneral.module.scss';
import { Result } from "../../types/SearchData";
import { clearTag } from '../../helpers/Utils';

interface ResultsGeneralProps {
    results: Result[];
    labels: { [key: string]: string };
    layout: 'list' | 'grid';
}

const ResultsGeneral: React.FC<ResultsGeneralProps> = ({ results, labels, layout }) => {
    const columnClass = layout === 'grid' ? 'col-lg-6' : 'col-12';

    return (
        <React.Fragment>
            {/* Results Section */}
            <section className={`${styles["results-general"]} section`}>

                <div className="container" data-aos="fade-up" data-aos-delay="100">

                    <div className="row gy-4">
                        {results?.map((result, index) => {
                            const hasLink = result?.link && result.link.trim() !== '';
                            const Tag = hasLink ? 'a' : 'div';
                            const tagProps = hasLink ? { href: result.link, title: result?.title } : {};
                            const p0 = layout === 'grid' ? (index % 2 == 0 ? 'pr-0' : 'pl-0') : 'pr-0 pl-0';
                            return (
                                <div className={`${columnClass} ${p0}`} key={index}>
                                    <Tag
                                        className={`${styles["result-item"]} position-relative`}
                                        {...tagProps}
                                    >
                                        <div className="row align-items-start">
                                            <div className="col-12">
                                                {result?.contentType && result?.contentType.length > 0 && <div className={styles["result-type"]}>
                                                    {result?.contentType}
                                                </div>}
                                                {result?.title && result?.title.length && <div className={styles["result-title"]} title={result?.title}>
                                                    <h3>{result?.title}</h3>
                                                </div>}
                                            </div>
                                            {result?.description && result?.description.length > 0 &&
                                                <div className="col-12 col-lg-11">
                                                    <div className={styles["result-content"]}>
                                                        <p dangerouslySetInnerHTML={{ __html: result?.description }} />
                                                    </div>
                                                </div>
                                            }
                                            {result?.categories && result?.categories?.length > 0 && <div className="col-12 col-lg-11">
                                                <div className={styles["categories"]}>
                                                <span>{labels["CategoriesLabel"]}</span>
                                                <ul>
                                                    {result?.categories?.map((category, index) => {
                                                        if (index == 0) return;
                                                        return (
                                                            <li key={index}>
                                                                {category}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                                </div>
                                            </div>
                                            }
                                            {result?.keywords && result?.keywords.length > 0 && 
                                                <div className="col-12 col-lg-11">
                                                    <div className={`${styles["result-tags"]} row no-gutters`}>
                                                        <div className="col-auto">
                                                            <span>{labels["KeywordsLabel"]}</span>
                                                        </div>
                                                        <div className="col">
                                                            <ul>
                                                                {result?.keywords?.map((tag, tagIndex) => {
                                                                    return (
                                                                        <li key={tagIndex}>{clearTag(tag)}</li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </Tag>
                                </div>
                            );
                        })}
                    </div>

                </div>

            </section>{/* /Results Section */}
        </React.Fragment>
    );
};

export default ResultsGeneral;
